module.exports = __webpack_public_path__ + "static/media/Dust.a0b89a82.jpg";